import axios from 'axios';

const API_URL = '/api/tenant/sales';

export const fetchSalesTickets = async (params) => {
  try {
    const queryParams = {
      page: params.page,
      pageSize: params.itemsPerPage || 20,
      q: params.q,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo,
    };

    Object.keys(queryParams).forEach((key) => {
      if (
        (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') &&
        key !== 'page' &&
        key !== 'pageSize'
      ) {
        delete queryParams[key];
      }
    });

    const response = await axios.get(`${API_URL}/tickets`, { params: queryParams });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales tickets:', error);
    throw error;
  }
};

export const fetchSalesTicketDetail = async (ticketId) => {
  try {
    const response = await axios.get(`${API_URL}/tickets/${ticketId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ticket detail ${ticketId}:`, error);
    throw error;
  }
};
